export const CUSTOMER = 'Startup Customer';
export const MEMBER = 'Member';
export const ADMINISTRATOR = 'Administrator';